import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { createClient, Provider } from 'urql'

import Header from "./Header"
import Footer from "./Footer"

const client = createClient({
  url: process.env.GATSBY_GRAPHCMS_ENDPOINT ?? ''
})

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <Provider value={client}>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      {children}
      <Footer />
    </Provider>
  )
}

export default Layout
